import { render } from "./PrivacyPolicy.vue?vue&type=template&id=3fac3836&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=ts"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=3fac3836&lang=less&scoped=true"
import "./PrivacyPolicy.vue?vue&type=style&index=1&id=3fac3836&lang=less"
script.render = render
script.__scopeId = "data-v-3fac3836"

export default script